import React from 'react'
import { object, array, string, func, bool } from 'prop-types'
import cx from 'classnames'
import { injectIntl } from 'react-intl'
import { Box } from '@chakra-ui/react'

import FontAwesomeIconComponent from 'src/components/FontAwesomeIcon'

import Button from 'src/components/Button/Button'
import Spin from 'src/components/Spin'
import UploadDropZone from './UploadDropZone'
import styles from './UploadList.module.less'
import intlMessagesApp from 'src/modules/App/translations'

const UploadList = props => {
  const {
    intl,
    dropZoneOptions,
    itemPreviewOnly,
    files,
    onFileAdded,
    onAllFilesAdded,
    onFileDelete,
    onFilePreview,
    addText,
    classNameFileHolder,
    uploadDropZoneClassNamesHolder,
    hideDropZoneWithFiles,
    isFullWidth,
    addClassNameFileHolder,
    size,
    isWidget,
  } = props

  const onDropSuccess = response => {
    if (typeof onFileAdded === 'function') {
      onFileAdded(response)
    }
  }

  const renderContent = dropZoneProps => {
    return (
      <div
        className={cx({
          [styles.addFileHolder]: true,
          [addClassNameFileHolder]: !!addClassNameFileHolder,
          [styles.addFileHolderSmall]: size,
        })}
      >
        {dropZoneProps.isUploadInProgress === true ? (
          <div>
            <Spin />
          </div>
        ) : (
          <>
            <Box mb={'20px'} opacity={0.3}>
              <FontAwesomeIconComponent icon={['far', 'upload']} size='md' />
            </Box>
            <Button
              h={'auto'}
              whiteSpace={'unset'}
              variant='dotted'
              isFullWidth={isFullWidth}
              size='md'
              border='1px solid var(--chakra-colors-brand-borderColor)'
              className={cx({ [styles.addText]: true })}
            >
              {addText || intl.formatMessage(intlMessagesApp.appGlobalAdd)}
            </Button>
          </>
        )}
      </div>
    )
  }

  const renderDragActiveContent = () => (
    <div className={styles.dropZoneOverlay}>
      <div className={styles.dropZoneOverlayInner}>
        <div>{intl.formatMessage(intlMessagesApp.picturesDropHere)}</div>
      </div>
    </div>
  )

  const allDropZoneOptions = {
    classNameHolder: cx({
      [styles.listItem]: true,
      [styles.uploadDropZoneHolder]: true,
      [uploadDropZoneClassNamesHolder]: !!uploadDropZoneClassNamesHolder,
    }),
    classNameDropZone: styles.uploadDropZone,
    classNameInner: cx({
      [styles.uploadDropZoneInner]: true,
      'kiosk--chakra-colors-card-background': true,
    }),
    onDropSuccess,
    onAllFilesAdded,
    renderContent,
    renderDragActiveContent,
    ...dropZoneOptions,
  }

  const itemPreview = (e, file) => {
    if (file && file.url) {
      if (typeof onFilePreview === 'function') {
        onFilePreview(e, file)
      }
    }
  }

  const itemDelete = (e, file) => {
    e.preventDefault()

    if (file && typeof onFileDelete === 'function') {
      onFileDelete(file)
    }
  }

  const classNamesListItem = cx({
    [styles.listItem]: true,
    [styles.fileHolder]: true,
    [classNameFileHolder]: !!classNameFileHolder,
  })

  return (
    <div
      className={cx({
        [styles.list]: true,
        [styles.listWithFiles]: files && files.length,
        [styles.listWithFilesOnWidget]: isWidget,
      })}
    >
      {!(hideDropZoneWithFiles === true && files.length > 0) ? (
        <UploadDropZone {...allDropZoneOptions} />
      ) : (
        ''
      )}
      {files.length > 0
        ? files.map((file, key) => {
            if (!file.url) {
              return false
            }
            return (
              <div key={'upload-list-item-' + key} className={classNamesListItem}>
                <div className={styles.file} style={{ backgroundImage: `url(${file.url})` }}>
                  {itemPreviewOnly === true ? (
                    <a
                      className={styles.filePreviewArea}
                      href={file.url}
                      target='_blank'
                      rel='noopener noreferrer'
                      onClick={e => itemPreview(e, file)}
                    >
                      &nbsp;
                    </a>
                  ) : (
                    <span className={styles.fileActions}>
                      {typeof onFilePreview === 'function' ? (
                        <a
                          href={file.url}
                          target='_blank'
                          rel='noopener noreferrer'
                          onClick={e => itemPreview(e, file)}
                        >
                          <button>
                            <FontAwesomeIconComponent
                              icon={['far', 'eye']}
                              size='xs'
                              addClassName={styles.fileActionIcon}
                            />
                          </button>
                        </a>
                      ) : (
                        ''
                      )}
                      <a href={file.url} target='_blank' rel='noopener noreferrer'>
                        <button>
                          <FontAwesomeIconComponent
                            icon={['far', 'download']}
                            size='xs'
                            addClassName={styles.fileActionIcon}
                          />
                        </button>
                      </a>
                      {typeof onFileDelete === 'function' ? (
                        <a
                          href={file.url}
                          target='_blank'
                          rel='noopener noreferrer'
                          onClick={e => itemDelete(e, file || null)}
                        >
                          <button>
                            <FontAwesomeIconComponent
                              icon={['far', 'trash-can']}
                              size='xs'
                              addClassName={styles.fileActionIcon}
                            />
                          </button>
                        </a>
                      ) : (
                        ''
                      )}
                    </span>
                  )}
                </div>
              </div>
            )
          })
        : ''}
    </div>
  )
}

UploadList.propTypes = {
  dropZoneOptions: object.isRequired,
  itemPreviewOnly: bool,
  files: array.isRequired,
  onFileAdded: func,
  onAllFilesAdded: func,
  onFileDelete: func,
  onFilePreview: func,
  addText: string,
  classNameFileHolder: string,
  uploadDropZoneClassNamesHolder: string,
  hideDropZoneWithFiles: bool,
}

export default injectIntl(UploadList)
